export const objectToArray = (object: Object) => Object.keys(object).map(prop => object[prop]);
